import { useTranslation } from "react-i18next";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { IconWithBackground } from "../../../components/IconWithBackground/IconWithBackground";
import { colors } from "../../../styles/colors";
import { motion } from "framer-motion";
import useStyles from "./styles";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { FC } from "react";

type Props = {
  fleetClients: number;
  partners: number;
  fleetEvolution: { month: string; total: number }[];
  partnerEvolution: { month: string; total: number }[];
};

export const FleetInfos: FC<Props> = ({
  fleetClients,
  partners,
  fleetEvolution,
  partnerEvolution,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.divContainerFleet}>
      <motion.div
        className={classes.divFleet}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7 }}
      >
        <div className={classes.divUsers}>
          <IconWithBackground
            iconName="userCircle"
            backgroundColor={colors.greenLight}
            iconColor={colors.greenDark}
            width={"28px"}
            height={"28px"}
          />
          <div className={classes.divChiffre}>
            <CustomTypography text={fleetClients.toString()} variant={"h2"} />
            <CustomTypography
              text={t(
                "dashboard.numberOfFleetCustomers",
                "Number of fleet customers"
              )}
              variant={"default"}
            />
          </div>
        </div>
        <div className={classes.divRecharts}>
          <ResponsiveContainer width="100%" height={"90%"}>
            <LineChart data={fleetEvolution}>
              <Line
                type="monotone"
                dataKey="total"
                stroke="#A5DFA0"
                strokeWidth={2}
                dot={{ r: 3 }}
              />
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </motion.div>

      <motion.div
        className={classes.divFleet}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7 }}
      >
        <div className={classes.divUsers}>
          <IconWithBackground
            iconName="userCircle"
            backgroundColor={colors.pinkLight}
            iconColor={colors.pinkDark}
            width={"28px"}
            height={"28px"}
          />
          <div className={classes.divChiffre}>
            <CustomTypography text={partners.toString()} variant={"h2"} />
            <CustomTypography
              text={t(
                "dashboard.numberOfPartners",
                "Number of partners"
              )}
              variant={"default"}
            />
          </div>
        </div>
        <div className={classes.divRecharts}>
          <ResponsiveContainer width="100%" height={"90%"}>
            <LineChart data={partnerEvolution}>
              <Line
                type="monotone"
                dataKey="total"
                stroke="#E87CBB"
                strokeWidth={2}
                dot={{ r: 3 }}
              />
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </motion.div>
    </div>
  );
};
